import type { IFilterXSSOptions } from "xss";

export const defaultXssSettings: IFilterXSSOptions = {
	whiteList: {
		sub: [],
		sup: [],
		br: [],
		b: [],
		strong: [],
		span: [],
	}
};

export const richTextXssSettings: IFilterXSSOptions = {
	whiteList: {
		sub: ["style"],
		sup: ["style"],
		br: ["style"],
		strong: ["style"],
		blockquote: ["style"],
		b: ["style"],
		em: ["style"],
		i: ["style"],
		p: ["style"],
		a: ["rel", "class", "href", "target", "tabindex", "style"],
		h2: ["style"],
		h3: ["style"],
		h4: ["style"],
		h5: ["style"],
		h6: ["style"],
		span: ["style"],
		div: ["style"],
		ul: ["style"],
		li: ["style"],
		table: ["style"],
		tr: ["style"],
		td: ["style"],
		th: ["style"],
	},
	css: false,
};